export default {
  SHOW_POPUP: 'SHOW_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP',
};
